function InputNumber() {
  const self = this;

  self.init = function init(element) {
    const $wrap = $(element);

    if ($wrap.data('app-module-initialized')) return; // Prevent double init

    const $field = $wrap.find('.js-input-number__field');
    const min = parseInt($field.attr('min'), 10);
    const max = parseInt($field.attr('max'), 10);

    $field.on('change', () => {
      let val = parseInt($field.val(), 10);

      if (Number.isNaN(val)) {
        val = min;
      } else if (val > max) {
        val = max;
      } else if (val < min) {
        val = min;
      }

      $wrap.toggleClass('is-removable', val === 0);
      $field.val(val);
    });

    $wrap.on('click', '.js-input-number__btn', function changeValue() {
      const $btn = $(this);
      const action = $btn.data('action');
      let val = parseInt($field.val(), 10);

      if (action === 'add') {
        val += 1;
      } else {
        val -= 1;
      }
      $field.val(val).change();
    });

    $wrap.data('app-module-initialized', true);
  };

  self.initAll = function initAll() {
    $('.js-input-number').each(function init() {
      self.init(this);
    });
  };
}

export default new InputNumber();
